import { defineMessages } from 'react-intl';

export default defineMessages({
  SLIDE_X: {
    defaultMessage: "Accéder à l'élément {number, number}",
  },
});
